/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { evaluate } from 'mathjs';
import { ConditionVisibility, UniversalTrackerPlain } from '../../../types/universalTracker';

interface ConditionalityResult {
  isDisabled?: boolean;
  isHidden?: boolean;
  userMessage?: string;
}

export const useConditionality = (
  conditions?: UniversalTrackerPlain['conditions'],
): ConditionalityResult => {
  const result: ConditionalityResult = {};

  if (!conditions) {
    return result;
  }

  conditions.forEach((condition) => {
    const evalResult = evaluate(condition.calculation.formula);
    if (evalResult) {
      if (condition.result.visibility === ConditionVisibility.Disabled) {
        result.isDisabled = true;
      }
      if (condition.result.visibility === ConditionVisibility.Hidden) {
        result.isHidden = true;
      }
      result.userMessage = condition.result.userMessage;
    }
  });

  return result;
};
